import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { GraphicsServices } from 'v2/resources/services/graphics';
import {
  IResponseBiometricParameters,
  IResponseBiometricsNurseries,
  IResponseHealthMortality,
  IResponseNurseryMortality,
  IResponseQualityParameters,
  IResponseSupply,
  IResponseWaterAnalysisNurseries,
} from 'v2/resources/types/graphics';

export const useQuerySupplies = (
  params: number | string
): UseQueryResult<IResponseSupply> => {
  return useQuery({
    queryKey: ['getSupply', params],
    queryFn: () => GraphicsServices.getSupply(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
export const useQueryNurseryMortality = (
  params: number | string
): UseQueryResult<IResponseNurseryMortality[]> => {
  return useQuery({
    queryKey: ['getNurseryMortality', params],
    queryFn: () => GraphicsServices.getNurseryMortality(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
export const useQueryHealthAnalysis = (
  params: number | string
): UseQueryResult<IResponseHealthMortality> => {
  return useQuery({
    queryKey: ['getHealthAnalysis', params],
    queryFn: () => GraphicsServices.getHealthAnalysis(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
export const useQueryQualityParameters = (
  params: number | string
): UseQueryResult<IResponseQualityParameters> => {
  return useQuery({
    queryKey: ['getWaterQualityParameters', params],
    queryFn: () => GraphicsServices.getWaterQualityParameters(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
export const useQueryBiometricsParameters = (
  params: number | string
): UseQueryResult<IResponseBiometricParameters> => {
  return useQuery({
    queryKey: ['getBiometricsParameters', params],
    queryFn: () => GraphicsServices.getBiometricsParameters(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export const useQueryBiometricsNurseries = (
  params: number | string
): UseQueryResult<IResponseBiometricsNurseries> => {
  return useQuery({
    queryKey: ['getBiometricsNurseries', params],
    queryFn: () => GraphicsServices.getBiometricsNurseries(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
export const useQueryWaterAnalysisNurseries = (
  params: number | string
): UseQueryResult<IResponseWaterAnalysisNurseries> => {
  return useQuery({
    queryKey: ['getWaterAnalysisNurseries', params],
    queryFn: () => GraphicsServices.getWaterAnalysisNurseries(params),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
